import { Box, Stack, Typography, alpha, styled } from '@mui/material';

export const ToggleRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '12px',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '14px',
  padding: '12px 14px',
}));

export const IconChip = styled(Box)(({ theme }) => ({
  width: 40,
  height: 40,
  borderRadius: '10px',
  flexShrink: 0,
  display: 'grid',
  placeItems: 'center',
  backgroundColor: alpha(theme.palette.primary.main, 0.08),
}));

export const CopyStack = styled(Stack)({
  flex: 1,
  gap: '2px',
  minWidth: 0,
});

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 700,
  color: theme.palette.text.primary,
}));

export const Subtitle = styled(Typography)(({ theme }) => ({
  fontSize: '12.5px',
  color: theme.palette.text.secondary,
}));
